import React, { useContext } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";

// import { Ionicons } from '@expo/vector-icons';
// import Icon from 'react-native-ionicons';
import { Ionicons as Icon, Foundation as FIcon } from '@expo/vector-icons';
import { ProductContext } from '../../contexts/product/Store';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'


interface IProps {
    title: string,
    isLoading?: boolean,
}

const ProductStackHeader: React.FC<IProps> = function ({ title, isLoading }) {


    const { product_state, product_dispatch } = useContext(ProductContext)

    const setProductView = (config: string) => {
        product_dispatch({ type: 'SET_PRODUCT_VIEW', payload: config })
    }

    return (
        <>
            <View style={styles.listMenu}>
                <Text style={styles.listMenuText}>{isLoading ? 'Fetching items' : title}</Text>
                <TouchableOpacity style={styles.listMenuIcon} onPress={() => setProductView('grid')}>
                    <Icon
                        name='grid'
                        size={18}
                        color={product_state.product_view === 'grid' ? Colors.tintColor : Colors.shades._1}
                    />
                </TouchableOpacity>
                <TouchableOpacity style={styles.listMenuIcon} onPress={() => setProductView('list')}>
                    <Icon
                        name='menu'
                        size={24}
                        color={product_state.product_view === 'list' ? Colors.tintColor : Colors.shades._1}
                    />
                </TouchableOpacity>
            </View>

        </>
    )
}

export default ProductStackHeader

ProductStackHeader.defaultProps = {
    isLoading: false
}

const styles = StyleSheet.create({
    listMenu: {
        paddingHorizontal: 16,
        paddingVertical: 8,
        flexDirection: 'row',
        backgroundColor: Colors.whiteColor,
    },
    listMenuText: {
        alignSelf: 'center',
        flexGrow: 1,
        width: 122,
        color: Colors.shades._7,
        ...FontStyles.size13,
        ...FontStyles.lh13,
        ...FontStyles.normal,
    },
    listMenuIcon: {
        alignSelf: 'center',
        padding: 3,
        marginLeft: 10,
    }
})